export const NAME = 'education'

export const SET_EDUCATION_FEATURES = `${NAME}/SET_EDUCATION_FEATURES`
export const SET_IS_AUTHENTICATED_FEATURES_LOADED = `${NAME}/SET_IS_AUTHENTICATED_FEATURES_LOADED`
export const SET_EDUCATION_EVENTS = `${NAME}/SET_EDUCATION_EVENTS`
export const ADD_EDUCATION_EVENT = `${NAME}/ADD_EDUCATION_EVENT`
export const SET_EDUCATION_EVENTS_PENDING = `${NAME}/SET_EDUCATION_EVENTS_PENDING`
